/**
 * This page is loaded by Nextjs:
 *  - on the server, when data-fetching methods throw or reject
 *  - on the client, when `getInitialProps` throws or rejects
 *  - on the client, when a React lifecycle method throws or rejects, and it's
 *    caught by the built-in Nextjs error boundary
 *
 * See:
 *  - https://nextjs.org/docs/basic-features/data-fetching/overview
 *  - https://nextjs.org/docs/api-reference/data-fetching/get-initial-props
 *  - https://reactjs.org/docs/error-boundaries.html
 */

import Bugsnag from '@bugsnag/js';
import { NextPageContext } from 'next';
import NextErrorComponent, { ErrorProps } from 'next/error';

const CustomErrorComponent = (props: ErrorProps) => (
    <NextErrorComponent statusCode={props.statusCode} />
);

CustomErrorComponent.getInitialProps = async (ctx: NextPageContext) => {
    if (ctx.err) {
        Bugsnag.notify(ctx.err, (event) => {
            event.context = ctx.err?.message;

            // Hack to coerce the embedded objects and structures into primitives
            // for more information surrounding the error.
            event.addMetadata('error', JSON.parse(JSON.stringify(ctx.err)));

            const headers = { ...ctx.req?.headers };
            headers.cookie = '<filtered out>';
            event.addMetadata('request', {
                url: ctx.req?.url,
                path: ctx.req?.url,
                headers: headers,
            });

            // Feel free to add additional properties to help with debugging in here
            event.addMetadata('debug info', {
                errorLocation: typeof window === 'undefined' ? 'server' : 'client',
            });
        });
    }
    return NextErrorComponent.getInitialProps(ctx);
};

export default CustomErrorComponent;
